<template>
  <div class="line">
    <div class="blue-border"></div>
    <div class="content">{{ title }}</div>
    <div class="horizon"><hr /></div>
  </div>
</template>
<style lang="scss" scoped>
.line {
  display: flex;
  align-items: center;
  .blue-border {
    background-color: #2a8ae0;
    width: 6px;
    height: 30px;
  }
  .content {
    margin: 0 20px;
  }
  .horizon {
    flex-grow: 1;
  }
}
</style>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
